import BaseTable from './base-table'
BaseTable.install = function (Vue) {
  Vue.component(BaseTable.name, BaseTable)
}
export default BaseTable
